import React from 'react';
import { SimpleFooter } from '../../footer/Footer';
import { AdminHeader } from '../plans/AdminHeader';
import { ReportsCourseUsersSection } from './ReportsCourseUsersSection';
/**
 * Creado por Equilibrio Agency 2022<br>
 * Página para mostrar contenido de sección usuarios
 * @return {HTMLElement} Elementos HTML de cada componente
 * @interface AdminHeader
 */
export const ReportsCourseUsersPage = () => {
  return (
    <>
      <AdminHeader />
      <div style={{ marginTop: '120px' }}></div>
      <ReportsCourseUsersSection />
      <SimpleFooter></SimpleFooter>
    </>
  );
};
